import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { PrivateRoute } from "../PrivateRoute";

export const AppRouter = ({ routes }) =>
  routes.map(
    ({
      path,
      Component,
      exact = false,
      isPrivate = false,
      hasAccess = true,
      isDisplayed = true,
      navigation = [],
    }) => {
      const RouteComponent = isPrivate ? PrivateRoute : Route;
      return (
        <RouteComponent
          path={`/participant${path}`}
          key={path}
          exact={exact}
          hasAccess={hasAccess}
          isDisplayed={isDisplayed}
        >
          {isDisplayed && <Component navigation={navigation} />}
        </RouteComponent>
      );
    }
  );

AppRouter.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      Component: PropTypes.elementType,
      exact: PropTypes.bool,
      isPrivate: PropTypes.bool,
      hasAccess: PropTypes.bool,
      isDisplayed: PropTypes.bool,
      navigation: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};
